var Evaluator = {
    noeval: false,
    protectedEval: false, // This property can be customized only by plugins
};
export default Evaluator;
